<template>
    <div id="crm_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div v-if="activityScheduleVal && activityScheduleVal != undefined">
            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="CrmForm">
                <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group hide">
                        <label class="control-label require" for="name">Module:</label>
                        <v-select v-model="modules" placeholder="Select Module."
                                label="text"
                                :options="moduleArr">
                        </v-select>
                        <div class="field-error">{{module_error_msg}}</div>
                    </div>
                    <div class="col form-group hide">
                        <label class="control-label require" for="customer_id">Customer:</label>
                        <v-select v-model="customer_id" name="customer_id"
                                label="text" :filterable="false" :options="customerArr"
                                @search="onSearchCustomer"
                                placeholder="Select Customer." class="custom-ci-auto-search">
                            <template slot="no-options">
                                Search Customer...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                {{ option.text }}
                                </div>
                            </template>
                        </v-select>
                        <div class="field-error">{{ customer_error_msg }}</div>
                    </div>
                    <div class="col form-group hide">
                        <label class="control-label require" for="location">Location:</label>
                        <v-select v-model="location_id" name="location" placeholder="Select Location."
                                label="text"
                                :options="locationArr" id="location">
                        </v-select>
                        <div class="field-error">{{ location_error_msg }}</div>
                    </div>
                    <div class="col form-group hide">
                        <label class="control-label require" for="user_id">User:</label>
                        <v-select v-model="user_id" name="user_id" id="user_id"
                            label="text" :filterable="false" :options="userArr"
                            @search="onSearchUser"
                            placeholder="Select User." class="custom-ci-auto-search contract-data">
                            <template slot="no-options">
                                Search User...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                        </v-select>
                        <div class="field-error">{{ user_error_msg }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label require" for="activity_type">Activity Type:</label>
                        <v-select v-model="activity_type" name="activity_type" placeholder="Select Activity Type."
                                label="text"
                                :options="activityTypeArr" id="activity_type">
                        </v-select>
                        <div class="field-error">{{ activity_type_error_msg }}</div>
                    </div>
                    <div class="col form-group hide">
                        <label class="control-label" for="vehicle_id">Asset:</label>
                        <v-select v-model="vehicle_id" name="vehicle_id"
                            label="text" :filterable="false" :options="vehicleArr"
                            @search="onSearchAsset"
                            placeholder="Select Asset." class="custom-ci-auto-search">
                            <template slot="no-options">
                                Search Asset...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="col form-group cal-personal-detail">
                        <div class="example-label">
                            <label class="control-label require">Activity Time:</label>
                        </div>
                        <div class="input-group">
                            <date-picker onkeydown="return false" placeholder="MM/DD/YYYY HH:MM:SS" id="activity_time" name="activity_time" v-model="activity_time" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                            <label for="activity_time" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                        </div>
                        <div class="field-error">{{ activity_time_error_msg }}</div>
                    </div>
                    <div class="col form-group">
                        <label class="control-label" for="notes">Notes:</label>
                        <input type="text" class="form-control" v-model="notes" id="notes" placeholder="Enter Notes." name="notes">
                    </div>
                </div>
                <div class="form-group">
                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong id="errorMsg1" class="field-error"></strong>
                    </div>
                </div>
                <div class="col-sm-12 btm-action-btn-fl">
                    <button type="submit" id="createCrmBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCrm">
                        <i class="fp-reload"> </i>  Update
                    </button>
                    <button type="submit" id="createCrmBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCrm">
                        <i class="fp-save"> </i>  Save
                    </button>
                    <button type="submit" id="createAndContinueCrmBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCrm(flag='Save and Continue')">
                        <i class="fp-save-continue"> </i>  Save and Continue
                    </button>
                    <button type="submit" id="cancelCrmBtn" class="btn btn-tertiary" v-on:click.prevent="BackCrmList">
                        <i class="fp-close"> </i>  Cancel
                    </button>
                </div>
                <app-activity-asset v-if="loadActivity" :moduleVal="activityScheduleVal" :assetIdVal="vehicle_id"></app-activity-asset>
            </form>
        </div>

        <div id="page-content-wrapper" :class="adminContentClass" v-else>
            <template v-if="cantAccessPage === true">
                <template v-if="fromModule === undefined">
                <div class="page-name">
                    <span class="page-title" id="crmHeader" v-if="$route.params.id > 0">Update Crm</span>
                    <span class="page-title" id="crmHeader" v-else>Add Crm</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackCrmList">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                </template>

                <template v-if="noDataFound === false">
                <div :class="containerFluidClass">
                    <div class="admin-page-content crm-crude">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="CrmForm">
                                <div class="form-row">
                                    <div class="col-md-4 form-group">
                                        <label class="require" for="comment_type_id">Subject:</label>
                                        <v-select v-model="comment_type_id" name="comment_type_id" placeholder="Select Comment Type" label="text"
                                            :options="commentTypeArr" @input="onCommentTypeSelect()">
                                        </v-select>
                                    </div>
                                    <div class="col-md-8 form-group" v-if="subjectVisible">
                                        <label for="subject_input">&nbsp;&nbsp;</label>
                                        <input type="text" class="form-control" v-model="subject" id="subject" placeholder="Enter Subject" name="subject">
                                        <span class="field-error">{{ subject_error_msg }}</span>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-3 row-cols-1">

                                    <template v-if="fromModule === undefined">
                                    <div class="col form-group">
                                        <!-- <label class="control-label require" for="customer_id">Customer:</label> -->
                                        <label class="control-label" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer." class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_id">Vendor:</label>
                                        <v-select v-model="vendor_id" name="vendor_id"
                                                label="text" :filterable="false" :options="vendorArr"
                                                @search="onSearchVendor"
                                                placeholder="Select Vendor." class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vendor...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vendor_error_msg }}</div>
                                    </div>
                                    </template>

                                    <template v-if="fromModule === undefined || (fromModule != undefined && fromModule.module == 'customer')">
                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchAsset"
                                            placeholder="Select Asset." class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require" for="activity_type">Activity Type:</label>
                                        <v-select v-model="activity_type" name="activity_type" placeholder="Select Activity Type."
                                                label="text"
                                                :options="activityTypeArr" id="activity_type">
                                        </v-select>
                                        <div class="field-error">{{ activity_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group cal-personal-detail">
                                        <div class="example-label">
                                            <label class="control-label require">Activity Time:</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker onkeydown="return false" @dp-change="onStartDateTimeChange" placeholder="MM/DD/YYYY HH:MM:SS" id="activity_time" name="activity_time" v-model="activity_time" :config="dateTimeConfigs.start" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="activity_time" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{ activity_time_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-1 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Notes:</label>
                                        <textarea class="form-control" v-model="notes" id="notes"  placeholder="Enter Notes." name="notes" ref="textarea" rows="3"></textarea>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="follow_up_date">Follow Up Date Time:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" @dp-change="onEndDateTimeChange" id="follow_up_date" name="follow_up_date" v-model="follow_up_date" :config="dateTimeConfigs.end"></date-picker>
                                            <label for="follow_up_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="priority">Priority:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="priority_yes">
                                                    Yes
                                                    <input type="radio" v-model="priority" :value="1" id="priority_yes" name="priority">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="priority_no">
                                                    No
                                                    <input type="radio" v-model="priority" :value="0" id="priority_no" name="priority">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="completed">Completed:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="completed_yes">
                                                    Yes
                                                    <input type="radio" v-model="completed" :value="1" id="completed_yes" name="completed">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="completed_no">
                                                    No
                                                    <input type="radio" v-model="completed" :value="0" id="completed_no" name="completed">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="user_id">Assigned To:</label>
                                        <v-select v-model="user_id" name="user_id" id="user_id"
                                            label="text" :filterable="false" :options="userArr"
                                            @search="onSearchUser"
                                            placeholder="Select User." class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ user_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <template v-if="fromModule != undefined">
                                        <template v-if="fromModule.flag === 'add'">
                                            <button type="submit" id="createCrmBtn" class="btn btn-primary" v-on:click.prevent="CreateCrm">
                                            <i class="fp-save"> </i>  Save
                                            </button>
                                            <button type="submit" id="createAndContinueCrmBtn" class="btn btn-tertiary" v-on:click.prevent="CreateCrm(flag='Save and Continue')">
                                            <i class="fp-save-continue"> </i>  Save and Continue
                                            </button>
                                        </template>
                                        <template v-else-if="fromModule.flag === 'update'">
                                            <button type="submit" id="createCrmBtn" class="btn btn-primary" v-on:click.prevent="CreateCrm">
                                            <i class="fp-reload"> </i>  Update
                                            </button>
                                        </template>
                                        <button type="submit" id="cancelCrmBtn" class="btn btn-tertiary" v-on:click.prevent="BackCrmList">
                                        <i class="fp-close"> </i>  Cancel
                                        </button>
                                    </template>
                                    <template v-else>
                                    <button type="submit" id="createCrmBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCrm">
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createCrmBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCrm">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCrmBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCrm(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCrmBtn" class="btn btn-tertiary" v-on:click.prevent="BackCrmList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                    </template>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
                </template>
                <template v-else-if="noDataFound === true">
                    <div class="container-fluid">
                        <div class="bg-white text-center">
                            <div class="error-details">
                                {{noDataMsg}}
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import moment from 'moment';
import CrmList from '@/components/CrmList.vue'
Vue.component("app-activity-asset", CrmList);

export default {
  name: "CrmCreate",

  mixins:[commonMixins,contractMixins],
  metaInfo() {
      if (this.activityScheduleVal == undefined && this.fromModule == undefined)
          return {
              title: (this.$route.params.id > 0) ? "Update CRM | " +process.env.COPYRIGHT_NAME : "Create CRM | " +process.env.COPYRIGHT_NAME
          }
  },
  props: {
    activityScheduleVal: {
        type: String,
        required: false,
        default:undefined
    },
    assetIdVal: {
        type: Object,
        required: false,
        default:undefined
    },
    customerIdVal: {
        type: String,
        required: false,
        default:undefined
    },
    customerNameVal: {
        type: String,
        required: false,
        default:undefined
    },
    locationIdVal: {
        type: Object,
        required: false,
        default:undefined
    },
    fromModule: {
        type: Object,
        required: false,
        default:undefined
    },
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    loading:false,
    module_error_msg: "",
    modules:null,
    moduleArr:[],
    customer_id:null,
    customerArr:[],
    customer_error_msg: "",
    user_id:null,
    userArr:[],
    user_error_msg: "",
    location_id:null,
    locationArr:[],
    location_error_msg: "",
    activity_type:{text: "Email", value: "email"},
    activityTypeArr:[],
    activity_type_error_msg:"",
    activity_time_error_msg:"",
    vehicle_id:null,
    vehicleArr:[],
    notes:"",
    activity_time:"",
    optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        showClose: true
    },
    loadActivity: false,
    moduleReference:null,
    moduleReferenceArr:[],
    showWOField: false,
    disableFields:false,
    from:'',
    customerVal:'',
    vendor_id: null,
    vendor_error_msg:"",
    vendorArr: [],
    subject:"",
    subject_error_msg:"",
    comment_type_id:null,
    commentTypeArr:[],
    priority:0,
    follow_up_date:"",
    optionsFollowUpDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
        useCurrent: false,
        showClose: true
    },
    note_category:"",
    adminContentClass:"admin-content-area",
    containerFluidClass:"container-fluid",
    module_id:"",
    completed:0,
    noDataFound:false,
    noDataMsg:"No Data Found or CRM Removed.",
    subjectVisible:false
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_crm') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if(userObj != null){
            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
            if(dateTimeFormat != null){
                console.log(dateTimeFormat);
                //set date time format in optionsDate format of date picker
            }

            self.location_id = {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};
            // self.user_id = {value: userObj["id"], text : self.ucString(userObj["first_name"]) + " " + self.ucString(userObj["last_name"])};
        }

        var webloc = window.location.href;

        var decodeStr = "";

        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

            decodeStr = atob(this.$route.query.data)

        }

        var url = new URL(webloc+"?"+decodeStr);
        var customer = JSON.parse(url.searchParams.get("customer"));
        console.log(decodeStr);
        if (customer && customer.value){
            self.customerVal = customer.value;
        }
        self.customer_id = customer;

        var from = url.searchParams.get("redirectFrom");
        if (from && from == 'custView'){
            self.from = 'custView';
        }

        //activityScheduleVal is not undefined
        if(self.activityScheduleVal != undefined){
            self.loadFieldData(['module','location','activity_type','all_comment']);
            self.activity_time = moment().format('MM/DD/YYYY hh:mm:ss a');
            self.modules = {value: self.activityScheduleVal, text : self.ucString(self.activityScheduleVal)};
            console.log(self.activityScheduleVal);
            console.log(self.assetIdVal);
            console.log(self.customerIdVal);
            console.log(self.customerNameVal);
            console.log(self.locationIdVal);

            if(self.assetIdVal != undefined){
                self.vehicle_id = self.assetIdVal;
            }
            if(self.customerIdVal != undefined && self.customerIdVal != null && self.customerNameVal != undefined){
                if (self.customerIdVal != null && self.customerIdVal != '-') {
                    if (self.customerNameVal != null && self.customerNameVal != '-') {
                        self.customer_id = { value : self.customerIdVal, text: self.customerNameVal};
                    }else{
                        self.customer_id = null;
                    }
                }else{
                    self.customer_id = null;
                }
                console.log(self.customer_id);
                console.log("if");
            }else{
                self.customer_id = null;
                console.log(self.customer_id);
                console.log("else");
            }

            if(self.locationIdVal != undefined){
                self.location_id = self.locationIdVal;
            }
            self.loadActivity = true;

        }else if (self.fromModule != undefined) {
            //from module
            self.adminContentClass = "";
            self.containerFluidClass = "";
            if (self.fromModule.module == "customer") {
                // self.loadFieldData(['module','location','activity_type','customer_comment']);
                //need to display all the comment type in customer view as discussed on call with AR team
                self.loadFieldData(['module','location','activity_type','all_comment']);
            }else if (self.fromModule.module == "vendor") {
                self.loadFieldData(['module','location','activity_type','vendor_comment']);
            }else if (self.fromModule.module == "voucher") {
                self.loadFieldData(['module','location','activity_type','vendor_comment']);
            }else if (self.fromModule.module == "invoice") {
                self.loadFieldData(['module','location','activity_type','invoice_comment']);
            }else if (self.fromModule.module == "payment receipt") {
                self.loadFieldData(['module','location','activity_type','payment_comment']);
            }else if (self.fromModule.module == "work order") {
                self.loadFieldData(['module','location','activity_type','work_order_comment']);
            }
            self.getPermissions();
            if (self.fromModule.flag != undefined) {
                if (self.fromModule.flag == "add") {
                    self.activity_time = moment().format('MM/DD/YYYY hh:mm:ss a');
                }else if (self.fromModule.flag == "update") {
                    if (self.fromModule.crm_id != undefined && self.fromModule.crm_id != null) {
                        self.loadCrm(self.fromModule.crm_id);
                    }
                }
            }

        }else{
            self.loadFieldData(['module','location','activity_type','all_comment']);
            self.getPermissions();

            if(!segments[3]){
                self.activity_time = moment().format('MM/DD/YYYY hh:mm:ss a');
                //set min date for the activity time
                self.dateTimeConfigs.end.minDate = self.activity_time;
            }

            setTimeout(function () {
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]) {
                    self.loadCrm(segments[3]);
                }
            }, 100);
        }



  },
  methods: {
    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {
            loading(true);
            self.searchField(loading, search, 'customer','');
        }
    },
    onSearchUser(search, loading) {
        var self = this;
        if (search.length > 0) {

            loading(true);
            self.searchField(loading, search, 'user', '');
        }
    },
    onSearchAsset(search, loading) {
        var self = this;
        if (search.length > 3) {
            loading(true);
            self.searchField(loading, search, 'vehicle');
        }

    },
    onSearchModuleReference(search, loading){
        var self = this;
        if(self.modules != null){
            if (search.length > 0) {
                self.searchModuleReference(search,self.modules.value);
            }
        }
    },
    searchModuleReference(searchValue,moduleName){
        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/module-reference/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: {
                module:moduleName,
                search:searchValue
            },
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.moduleReferenceArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'serch-module-referance')
            }
        });
    },
    BackCrmList() {
      var self = this;
      if (self.from == 'custView' && self.customerVal != ''){
          self.$router.push("/dealer/view/"+self.customerVal+'?from=crm');
          return;
      }
      if(self.activityScheduleVal != undefined){
        self.$root.$emit('activity');
      }else if (self.fromModule != undefined) {
          self.$parent.cancelCrmFromView();
      }else{
        self.$router.push("/crm/list");
      }
    },

    CreateCrm(flag) {
      var self = this;
      var error = false;
      self.module_error_msg = "";
      self.customer_error_msg = "";
      self.location_error_msg = "";
      self.user_error_msg = "";
      self.activity_type_error_msg = "";
      self.activity_time_error_msg = "";
      self.subject_error_msg = "";

      //if current component is loaded
      if(self.activityScheduleVal == undefined){

        if (!self.subject || self.subject == null || self.subject.trim() == "") {
            self.subject_error_msg = "Subject Required.";
            error = true;
        }
        if (self.fromModule == undefined) {
            if (self.customer_id != null && self.vendor_id != null) {
                if (self.customer_id.value && self.vendor_id.value) {
                    self.customer_error_msg = "Customer or Vendor Required.";
                    error = true;
                }
            }
        }
      }

      if (self.activity_type == null || !self.activity_type.value) {
        self.activity_type_error_msg = "Activity Type Required.";
        error = true;
      }

      if($("#activity_time").val() == "" || $("#activity_time").val() == null){
        self.activity_time_error_msg = "Activity Time Required.";
        error = true;
      }

      if(!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            var fields = $("#CrmForm").serializeArray();
            if(self.activityScheduleVal != undefined){
                fields.push({name: "module", value: self.modules.value});
                fields.push({name: "from", value: self.modules.value});
            }else{
                //for existing records in case of update
                if (self.modules != null) {
                    fields.push({name: "module", value: self.modules.value});
                }else{
                    if (self.fromModule == undefined) {
                        fields.push({name: "module", value: "other"});//default module name
                        fields.push({name: "note_category", value: "other"});
                    }
                }
            }

            if (self.fromModule == undefined) {
                if(self.customer_id == null){
                    fields.push({name: "customer_id", value: ""});
                }else{
                    fields.push({name: "customer_id", value: self.customer_id.value});
                }
                if(self.vendor_id == null){
                    fields.push({name: "vendor_id", value: ""});
                }else{
                    fields.push({name: "vendor_id", value: self.vendor_id.value});
                }
            }

            fields.push({name: "location_id", value: self.location_id.value});
            if(self.user_id != null){
                fields.push({name: "user_id", value: self.user_id.value});
            }else{
                fields.push({name: "user_id", value: ""});
            }
            fields.push({name: "activity_type", value: self.activity_type.value});
            if(self.vehicle_id == null){
                fields.push({name: "vehicle_id", value: ""});
            }else{
                fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            }

            if(self.activityScheduleVal == undefined){
                if (self.fromModule == undefined) {
                    if (self.customer_id != null) {
                        fields.push({name: "module_id", value: self.customer_id.value});
                    }
                    if (self.vendor_id != null) {
                        fields.push({name: "module_id", value:self.vendor_id.value});
                    }
                    fields.push({name: "id", value: segments[3]});
                }else{
                    if (self.fromModule.module != undefined) {
                        if (self.fromModule.module == "customer") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.customer_id});
                            }
                            fields.push({name: "customer_id", value: self.fromModule.customer_id});
                            fields.push({name: "note_category", value: "receivable"});
                            fields.push({name: "from", value: "customer"});
                        }else if (self.fromModule.module == "vendor") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.vendor_id});
                            }
                            fields.push({name: "vendor_id", value: self.fromModule.vendor_id});
                            fields.push({name: "note_category", value: "payable"});
                            fields.push({name: "from", value: "vendor"});
                        }else if (self.fromModule.module == "voucher") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.bill_id});
                            }
                            fields.push({name: "vendor_id", value: self.fromModule.vendor_id});
                            fields.push({name: "note_category", value: "payable"});
                            fields.push({name: "from", value: "voucher"});
                        }else if (self.fromModule.module == "invoice") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.invoice_id});
                            }
                            fields.push({name: "customer_id", value: self.fromModule.customer_id});
                            fields.push({name: "note_category", value: "receivable"});
                            if(self.fromModule.vehicle_id != undefined && self.fromModule.vehicle_id != null){
                                fields.push({name: "vehicle_id", value: self.fromModule.vehicle_id});
                            }else{
                                fields.push({name: "vehicle_id", value: ""});
                            }
                            fields.push({name: "from", value: "invoice"});
                        }else if (self.fromModule.module == "payment receipt") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.receipt_item_id});
                            }
                            if (self.fromModule.customer_id != "" && self.fromModule.customer_id != null) {
                                fields.push({name: "customer_id", value: self.fromModule.customer_id});
                                fields.push({name: "note_category", value: "receivable"});
                            }else{
                                fields.push({name: "note_category", value: "other"});
                            }
                            fields.push({name: "from", value: "payment receipt"});
                        }else if (self.fromModule.module == "work order") {
                            if (self.module_id != "") {
                                fields.push({name: "module_id", value: self.module_id});
                            }else{
                                fields.push({name: "module_id", value: self.fromModule.work_order_id});
                            }
                            if (self.fromModule.customer_id != "" && self.fromModule.customer_id != null) {
                                fields.push({name: "customer_id", value: self.fromModule.customer_id});
                                fields.push({name: "note_category", value: "receivable"});
                            }else{
                                fields.push({name: "note_category", value: "other"});
                            }
                            if(self.fromModule.vehicle_id != undefined && self.fromModule.vehicle_id != null){
                                fields.push({name: "vehicle_id", value: self.fromModule.vehicle_id});
                            }else{
                                fields.push({name: "vehicle_id", value: ""});
                            }
                            fields.push({name: "from", value: "work order"});
                        }

                        if (self.fromModule.crm_id == "") {
                            fields.push({name: "id", value: ""});
                        }else{
                            fields.push({name: "id", value: self.fromModule.crm_id});
                        }
                    }
                }
            }
            if (self.comment_type_id != null && self.comment_type_id.value){
                fields.push({name: "subject_id", value: self.comment_type_id.value});
            }
            fields.push({name: "priority", value: self.priority});
            fields.push({name: "completed", value: self.completed});
            fields.push({name: "subject", value: self.subject});

            if (segments[3])
            {
                $("#createCrmBtn").val("Updating ...");
                $("#createCrmBtn").prop("disabled", true);
                $("#cancelCrmBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCrmBtn").val("Saving ...");
                    $("#createCrmBtn").prop("disabled", true);
                    $("#createAndContinueCrmBtn").prop("disabled", true);
                    $("#cancelCrmBtn").prop("disabled",true);

                }else{

                    $("#createCrmBtn").val("Saving ...");
                    $("#createCrmBtn").prop("disabled", true);
                    $("#createAndContinueCrmBtn").prop("disabled", true);
                    $("#cancelCrmBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/crm/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createCrmBtn").val("Update");
                        $("#createCrmBtn").prop("disabled", false);
                        $("#cancelCrmBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCrmBtn").val("Save and Continue");
                            $("#createCrmBtn").prop("disabled", false);
                            $("#createAndContinueCrmBtn").prop("disabled", false);
                            $("#cancelCrmBtn").prop("disabled",false);

                        }else{

                            $("#createCrmBtn").val("Save");
                            $("#createCrmBtn").prop("disabled", false);
                            $("#createAndContinueCrmBtn").prop("disabled", false);
                            $("#cancelCrmBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        var userObj = JSON.parse(localStorage.getItem("user_obj"));
                        if(userObj != null){
                            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
                            if(dateTimeFormat != null){
                                // load current date time
                                self.activity_time = moment().format('MM/DD/YYYY hh:mm:ss a');
                            }
                            //load logged in User and Location
                            self.location_id = {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};
                            self.user_id = {value: userObj["id"], text : self.titleCase(userObj["first_name"]) + " " + self.titleCase(userObj["last_name"])};
                        }

                        if (flag == "Save and Continue") {

                            if(self.activityScheduleVal != undefined){
                                self.activity_type = {text: "Email", value: "email"};
                                self.notes = "";
                                self.$root.$emit('activity_refresh');
                            }else{
                                $("#CrmForm").trigger("reset");
                                self.modules = null;
                                self.customer_id = null;
                                self.activity_type = {text: "Email", value: "email"};
                                self.vehicle_id = null;
                                self.notes = "";
                                self.moduleReference = null;
                                self.moduleReferenceArr = [];
                                self.showWOField = false;
                                self.comment_type_id = null;
                                self.subject = "";
                                self.follow_up_date = "";
                                $("#priority_no").prop("checked",true);
                                $("#completed").prop("checked",true);
                                self.priority = 0;
                                self.completed = 0;
                            }

                        }else if (self.from == 'custView' && self.customerVal != ''){
                            self.$router.push("/dealer/view/"+self.customerVal+'?from=crm');
                            return;
                        }
                        else if(self.activityScheduleVal != undefined){
                            self.notes = "";
                            self.$root.$emit('activity');
                        }else if(self.fromModule != undefined){
                            self.$parent.cancelCrmFromView();
                        }else{
                            self.$router.push("/crm/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            if(self.activityScheduleVal != undefined){
                                $("#errorMsg1").html(err);
                            }else{
                                $("#errorMsg").html(err);
                            }
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createCrmBtn").val("Update");
                        $("#createCrmBtn").prop("disabled", false);
                        $("#cancelCrmBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#CrmForm").trigger("reset");

                            $("#createAndContinueCrmBtn").val("Save and Continue");
                            $("#createCrmBtn").prop("disabled", false);
                            $("#createAndContinueCrmBtn").prop("disabled", false);
                            $("#cancelCrmBtn").prop("disabled",false);

                        }else{

                            $("#createCrmBtn").val("Save");
                            $("#createCrmBtn").prop("disabled", false);
                            $("#createAndContinueCrmBtn").prop("disabled", false);
                            $("#cancelCrmBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'create-crm-data')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },

    // loadCrm() {
    loadCrm(crmId) {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            // url: process.env.ROOT_API + "/crm/" + segments[3],
            url: process.env.ROOT_API + "/crm/" + crmId,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    if (data.content.editable != undefined && data.content.editable != null) {
                        if (data.content.editable == 1) {
                            self.noDataFound = false;
                        }else{
                            //crm not editable
                            self.noDataFound = true;
                            self.noDataMsg = "CRM cannot be Updated.";
                        }
                    }else{
                        self.noDataFound = false;
                    }
                    self.modules = {value:data.content.module,text:self.ucString(data.content.module)};
                    if(data.content.module == "work order" || data.content.module == "customer estimate"){
                        self.showWOField = true;
                    }else{
                        self.showWOField = false;
                    }

                    if(data.content.customer_id != null){
                        self.customer_id = {value:data.content.customer_id,text:data.content.cName + " (" + data.content.cCode + ")"};
                    }else{
                        self.customer_id = null;
                    }
                    if(data.content.subject_id != null){
                        self.comment_type_id = {value:data.content.subject_id,text:data.content.comment_code + " | " + data.content.comment_name,name:data.content.comment_name};

                        if (data.content.comment_name == 'Other'){
                            self.subjectVisible = true;
                        }
                    }else{
                        self.comment_type_id = null;
                    }
                    self.location_id = {value:data.content.location_id,text:data.content.lName + " (" + data.content.lCode + ")"};
                    if (data.content.user_id != null) {
                        if (data.content.uLastName && data.content.uLastName != null && data.content.uLastName != ''){
                            self.user_id = {value:data.content.user_id,text:self.ucString(data.content.uFirstName) + " " + self.ucString(data.content.uLastName) };

                        }else{
                            self.user_id = {value:data.content.user_id,text:self.ucString(data.content.uFirstName) };

                        }
                    }else{
                        self.user_id = null;
                    }
                    self.activity_type = {value:data.content.activity_type,text:self.titleCase(data.content.activity_type)};
                    if(data.content.vehicle_id != null){
                        // if(data.content.vtCode != null){
                        //     self.vehicle_id = {value:data.content.vehicle_id,text:data.content.vUnitNo + " (" + data.content.vName + ") (" + data.content.vtCode + ")"};
                        // }else{
                        //     self.vehicle_id = {value:data.content.vehicle_id,text:data.content.vUnitNo + " (" + data.content.vName + ") ()"};
                        // }
                        var vehicleData = self.titleCase(data.content.vUnitNo);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vName != null){
                            vehicleData += " | " + self.titleCase(data.content.vName);
                        }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                    }else{
                        self.vehicle_id = null;
                    }
                    self.notes = data.content.notes;
                    self.activity_time = data.content.activity_time;
                    self.disableFields = true;
                    if (data.content.subject != undefined && data.content.subject != null && data.content.subject != "") {
                        self.subject = data.content.subject;
                    }
                    if(data.content.vendor_id != undefined && data.content.vendor_id != null){
                        self.vendor_id = {value:data.content.vendor_id,text:data.content.vendor_name + " (" + data.content.vendor_code + ")"};
                    }else{
                        self.vendor_id = null;
                    }
                    if (data.content.follow_up_date != undefined && data.content.follow_up_date != null && data.content.follow_up_date != "") {
                        self.follow_up_date = data.content.follow_up_date;
                    }
                    if (data.content.priority != undefined && data.content.priority != null) {
                        self.priority = data.content.priority;
                    }
                    if (data.content.module_id != "" && data.content.module_id != null ) {
                        self.module_id = data.content.module_id;
                    }
                    if (data.content.completed != undefined && data.content.completed != null) {
                        self.completed = data.content.completed;
                    }
                }else{
                    if (data.code == 201) {
                        self.noDataFound = true;
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-crm-data-by-id')
            }
        });
    },
    onSearchVendor(search, loading) {
        var self = this;
        self.po_error_msg = "";
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },
    onCommentTypeSelect(){
        var self = this;
        self.subject_error_msg = "";
        if (self.comment_type_id != null) {
            if (self.comment_type_id.value) {
                if (self.comment_type_id.name && self.comment_type_id.name != null) {
                    if (self.comment_type_id.name != 'Other'){
                        self.subject = self.comment_type_id.name;
                    }
                    // self.comment_type_id = null;
                }
                if (self.comment_type_id.name != undefined && self.comment_type_id.name == 'Other'){
                    self.subjectVisible = true;
                }
            }
        }
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/CrmCreate.vue